  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
  import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import Checkbox                                            from '@material-ui/core/Checkbox';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';
  import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
//import { createFilterOptions }                             from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
  import Popover                                             from '@material-ui/core/Popover';
  import IconButton                                          from '@material-ui/core/IconButton';
  import InputAdornment                                      from '@material-ui/core/InputAdornment';
  import Typography                                          from '@material-ui/core/Typography';
  import InfoIcon                                            from '@material-ui/icons/Info';
  //[PASSWORDTYPE]
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import IconButton                                          from '@material-ui/core/IconButton';
  import Visibility                                          from '@material-ui/icons/Visibility';
  import VisibilityOff                                       from '@material-ui/icons/VisibilityOff';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';
  //recaptcha_V2
  import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //recaptcha_V3
//import useRecaptchaV3                                      from "components/useRecaptchaV3/useRecaptchaV3.jsx";
  import { GoogleReCaptchaProvider, GoogleReCaptcha }        from 'react-google-recaptcha-v3';
//import moment                                              from "moment";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CountriesStatesCitiesService }                 from "../../_services";
  import { wu_RegisterLightService }                         from "../../_services";
//import { wu_ProfileService }                               from "../../_services";
  import { wu_GeolocationService }                           from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import RegisterLight1Style                                      from "./RegisterLight1Style.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import img2                                                from "assets/img/wu/testImg2.png";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //[Campaign]
  import WU_popup_campaign_el                                from "assets/img/wu/popup_campaign_el.png";
  import WU_popup_campaign_en                                from "assets/img/wu/popup_campaign_en.png";
  //----------
  // variables
  //----------
  const filename = "RegisterLight1 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[flagsimages]
  var images = null;

  //[Lockers]
  var RegisterLight1_continue_locked = true;

class RegisterLight1 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    let email     = "";
    let password1 = "";
    let password2 = "";
    let phoneNumber   = "";

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      //[RECAPTCHA]
      recaptchaVersionSupported                            : "V3", //"V2", "V3", "NONE"
      //recaptcha_V3
      refreshReCaptchaV3                                   : false,

      email                                                : email,            //TextField
      email_disabled                                       : false,
      email_hasError                                       : false,
      password1                                            : password1,        //TextField
      password1_hasError                                   : false,
      password2                                            : password2,        //TextField
      password2_hasError                                   : false,
    //preferredLanguage_text                               : "",               //DropDown---language
    //preferredLanguage_id                                 : "",
    //preferredLanguage_hasError                           : false,
      state_code_text                                      : "",               //DropDown
      state_code_id                                        : "",
      phonePrefix_id                                       : "",               //DropDown
      phonePrefix_text                                     : "",
      phonePrefix_hasError                                 : false,
      phonePrefix_disabled                                 : false,
      phonePrefix_AUTOCOMPLETE_MODE                        : "object", //"text","object";
      phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS              : "any",    //"start","any"
      phoneNumber                                          : phoneNumber,      //TextField
      phoneNumber_hasError                                 : false,
      phoneNumber_disabled                                 : false,
      isMobile                                             : false,            //CheckBox

    //consent_view_hidden                                  : false,            //Consent---old
    //consentValue                                         : "",
    //bool_sel1                                            : false,
    //bool_sel2                                            : false,

      userGivesConsent                                     : false,            //Consent---new
      userAcceptedTerms                                    : false,

      parserObject_getCountries                            : [],
      parserObject_getCountries4Picker                     : [],
      parserObject_getLanguages                            : [],
      parserObject_getLanguages4Picker                     : [],
      parserObject_getPhonePrefixes                        : [],
      parserObject_getPhonePrefixes4Picker                 : [],

      // parserObject_getDays                                 : [],
      // parserObject_getMonths                               : [],
      // parserObject_getYears                                : [],

      passwordType1                                        : "password",
      passwordType2                                        : "password",

      //popup checkAppVersion
      dialog_checkAppVersion_isOpen                          : false,
      dialog_checkAppVersion_msg                             : "",

      //[POPOVER]
      password1_popover_isOpen                             : false,
      password2_popover_isOpen                             : false,

      //[Campaign]
      dialog101_msg                                        : "",
      dialog101_isOpen                                     : false,
      dialog101_campaign_image_w                           : "512",
      dialog101_campaign_image_h                           : "268",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                                      = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);

    this.btn_next_act                                                = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                                     = this.btn_next_act_isDisabled.bind(this);
    //recaptcha_V2
    this.btn_next_act_with_recaptcha                                 = this.btn_next_act_with_recaptcha.bind(this);
    this.recaptchaRef                                                = React.createRef();
    //recaptcha_V3
    this.btn_next_act_get_recaptchaV3_token                          = this.btn_next_act_get_recaptchaV3_token.bind(this);
    this.reset_recaptchaV3_token                                     = this.reset_recaptchaV3_token.bind(this);

  //this.handleCustomDropDownClick_languages                         = this.handleCustomDropDownClick_languages.bind(this);

    this.handleCustomDropDownClick_phonePrefix                       = this.handleCustomDropDownClick_phonePrefix.bind(this);
    this.handleCheckBoxClick_isMobile                                = this.handleCheckBoxClick_isMobile.bind(this);

  //this.handleRadioButtonClick_consent                              = this.handleRadioButtonClick_consent.bind(this);       //consent---old
    this.handleCheckBoxClick_userGivesConsent                        = this.handleCheckBoxClick_userGivesConsent.bind(this); //consent---new
    this.handleCheckBoxClick_userAcceptedTerms                       = this.handleCheckBoxClick_userAcceptedTerms.bind(this);

    //[SAVE STATE]
    this.saveState                                                   = this.saveState.bind(this);

    //popup checkAppVersion
    this.dialog_checkAppVersion_handleOpen                           = this.dialog_checkAppVersion_handleOpen.bind(this);
    this.dialog_checkAppVersion_btn_ok                               = this.dialog_checkAppVersion_btn_ok.bind(this);

    this.get_PasswordType1                                           = this.get_PasswordType1.bind(this);
    this.handlePopoverOpen_passwordType1                             = this.handlePopoverOpen_passwordType1.bind(this);
    this.get_PasswordType2                                           = this.get_PasswordType2.bind(this);
    this.handlePopoverOpen_passwordType2                             = this.handlePopoverOpen_passwordType2.bind(this);

    //[POPOVER]
    this.handlePopoverOpen_password1                                 = this.handlePopoverOpen_password1.bind(this);
    this.handlePopoverClose_password1                                = this.handlePopoverClose_password1.bind(this);
    this.handlePopoverClose_password2                                = this.handlePopoverClose_password2.bind(this);
    this.handlePopoverOpen_password2                                 = this.handlePopoverOpen_password2.bind(this);

    //[CAMPAIGN]
    this.dialog101_handleOpen                                        = this.dialog101_handleOpen.bind(this);
    this.dialog101_handleClose                                       = this.dialog101_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    //[Lockers]
    this.stopLockers();

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="SettingsPrivacy"    ||
       localStorage.getItem("prev_view").trim()==="SettingsTerms"      ||
       localStorage.getItem("prev_view").trim()==="SettingsTermsBills" ){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      this.stopSpinners();//this.stopLockers();
      return;
    }
    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    this.clear_cardpayment_transfer_cookies();
    this.clear_cardpayment_bill_cookies();
    //--------------------
    //global variables set
    //--------------------
    try { localStorage.setItem("newRegistrationFlow","newCustomer"); } catch(err){;}

    // let currYear = parseInt((new Date()).getFullYear());
    // let parserObject_getDays_TMP   = [];
    // let parserObject_getMonths_TMP = [];
    // let parserObject_getYears_TMP  = [];
    // for(let i=1;            i<32;            ++i){parserObject_getDays_TMP.push(i.toString());}
    // for(let i=1;            i<13;            ++i){parserObject_getMonths_TMP.push(i.toString());}
    // for(let i=currYear-100; i<currYear-18+1; ++i){parserObject_getYears_TMP.push(i.toString());}
    // this.setState({
    //   "parserObject_getDays"   : parserObject_getDays_TMP,
    //   "parserObject_getMonths" : parserObject_getMonths_TMP,
    //   "parserObject_getYears"  : parserObject_getYears_TMP,
    // });

    //[flagsimages]
    images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
    //if(api.print_logs){console.log("images.length="+images.length);}
    //for (var key in images) { if(api.print_logs){console.log("key="+key);} }

    //consent---old
    //this.setState({ "bool_sel1":false, "bool_sel2":false, "consent_view_hidden":false});

    //this.startSpinners();
    //------------
    //getCountries---CACHED
    //------------
    let retrieveWSData_getCountries = wu_CountriesStatesCitiesService.wu_should_getCountries();
    if(retrieveWSData_getCountries){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_CountriesStatesCitiesService
      .wu_getCountries({})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        var parserObject_getCountries4Picker = [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      })
      .catch(err => {
        //this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        console.log(methName+"err="+JSON.stringify(err));
        let res = wu_StaticDataService.wu_get_cached_countries({});
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker,
        });
      });
    }
    else{
      try{
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_getCountries="+retrieveWSData_getCountries);}
        let res = JSON.parse(localStorage.getItem("countries"));
        var parserObject_getCountries4Picker= [];
        for(let i=0; i<res.countries.length; ++i){ parserObject_getCountries4Picker.push(res.countries[i]["descr_el"]); }
        this.setState({
          "parserObject_getCountries"        : res.countries,
          "parserObject_getCountries4Picker" : parserObject_getCountries4Picker
        });
      }catch(err){
        console.log('err='+err);
      }
    }
    //---------------
    //wu_getLanguages---STATIC
    //---------------
    // var res_obj_getLanguages = wu_StaticDataService.wu_getLanguages({});
    // var parserObject_getLanguages4Picker_el = [];
    // var parserObject_getLanguages4Picker_en = [];
    // let descr_getLanguages_el = "descr_el";
    // let descr_getLanguages_en = "descr_en";
    // for(let i=0; i<res_obj_getLanguages.languages.length; ++i){ parserObject_getLanguages4Picker_el.push(res_obj_getLanguages.languages[i][descr_getLanguages_el]); }
    // for(let i=0; i<res_obj_getLanguages.languages.length; ++i){ parserObject_getLanguages4Picker_en.push(res_obj_getLanguages.languages[i][descr_getLanguages_en]); }
    // this.setState({ "parserObject_getLanguages_el"        : res_obj_getLanguages.languages });
    // this.setState({ "parserObject_getLanguages_en"        : res_obj_getLanguages.languages });
    // this.setState({ "parserObject_getLanguages4Picker_el" : parserObject_getLanguages4Picker_el });
    // this.setState({ "parserObject_getLanguages4Picker_en" : parserObject_getLanguages4Picker_en });
    // this.setState({ "preferredLanguage_text"              : "" });
    // this.setState({ "preferredLanguage_id"                : "" });

    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    var res_obj = wu_StaticDataService.wu_getPhonePrefixes({});
    var parserObject_getPhonePrefixes4Picker = [];
    for(var i=0; i<res_obj.phone_prefixes.length; ++i){
      //     if(res_obj.phone_prefixes[i]["ctry_wu_id"]==="US"){parserObject_getPhonePrefixes4Picker.push(res_obj.phone_prefixes[i]["descr"]+" - USA");}
      //else if(res_obj.phone_prefixes[i]["ctry_wu_id"]==="GB"){parserObject_getPhonePrefixes4Picker.push(res_obj.phone_prefixes[i]["descr"]+" - GB"); }
      //else if(res_obj.phone_prefixes[i]["ctry_wu_id"]==="AE"){parserObject_getPhonePrefixes4Picker.push(res_obj.phone_prefixes[i]["descr"]+" - UAE");}
      //else                                                   {parserObject_getPhonePrefixes4Picker.push(res_obj.phone_prefixes[i]["descr"]);         }
      parserObject_getPhonePrefixes4Picker.push(res_obj.phone_prefixes[i]["descr"]);
    }
    this.setState({
      "parserObject_getPhonePrefixes"        : res_obj.phone_prefixes,
      "parserObject_getPhonePrefixes4Picker" : parserObject_getPhonePrefixes4Picker
    });

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
    //--------------
    //wu_geolocation
    //--------------
    wu_GeolocationService
    .wu_geolocation({}) //componentWillMount
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="RegisterLight1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_geolocation",JSON.stringify(res.location)); if(api.print_logs){console.log("JSON.stringify(res)="+JSON.stringify(res));}
      let ws_country = "";
      try {ws_country = res.location["country"]; }catch(err){;} if(ws_country === null || (typeof ws_country ==="undefined")){ws_country = "";}
      let countryFound = false;
      for(let i=0; ws_country!=="" && i<res_obj.phone_prefixes.length; ++i){
        if(res_obj.phone_prefixes[i]["descr"].indexOf(ws_country)>=0){
          countryFound = true;
          this.setState({
            phonePrefix_id            : res_obj.phone_prefixes[i]["c2c_wu_id"],
            phonePrefix_text          : this.state.phonePrefix_AUTOCOMPLETE_MODE==="text" ? res_obj.phone_prefixes[i]["descr"] : res_obj.phone_prefixes[i],
            phonePrefix_hasError      : false,
            phonePrefix_disabled      : false,
            phoneNumber_hasError      : false,
            phoneNumber_disabled      : false,
          });
          break;
        }
      }
      if(countryFound===false){
        this.setState({
          phonePrefix_id            : "",               //DropDown
          phonePrefix_text          : this.state.phonePrefix_AUTOCOMPLETE_MODE==="text" ? "" : {},
          phonePrefix_hasError      : false,
          phoneNumber_disabled      : false,
          phoneNumber_hasError      : false,
        });
      }
      this.checkAppVersion();
    })
    .catch(err => {
      this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      console.log(methName+"err="+JSON.stringify(err));
    //if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
    //else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });

    //[CAMPAIGN]
    //wu_Utilities.campaign_clear_statsView(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,filename.trim());
    wu_Utilities.campaign_record_load(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim());
    if(wu_Utilities.campaign_should_show(api.campaign_enabled,api.campaign_prefix,api.campaign_cap_per_session,api.campaign_startDate,api.campaign_endDate,filename.trim())===true){
      console.log("campaigns window.innerWidth="+window.innerWidth);
      if(window.innerWidth > 960){ this.setState({"dialog101_campaign_image_w":"512","dialog101_campaign_image_h":"268",}); }
      else                       { this.setState({"dialog101_campaign_image_w":"256","dialog101_campaign_image_h":"134",}); }
      this.dialog101_handleOpen("");
    }
  }
  //----------------------------------------------------------------------------------------------------
  checkAppVersion(){
    let methName = filename+"checkAppVersion ";
    if(api.print_logs){console.log(methName);}

    //---------------
    //checkAppVersion---CACHED
    //---------------
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let retrieveWSData_checkAppVersion = wu_AppVersion.wu_should_checkAppVersion();
    if(retrieveWSData_checkAppVersion){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        if(res.isMajorUpdate===true){
          this.dialog_checkAppVersion_handleOpen(res.returnText);
          return;
        }
        //this.nextMethod();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //this.nextMethod();
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //this.nextMethod();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    //-----------
    //recaptchaV3
    //-----------
    var recaptchaTokenV3 = localStorage.getItem("recaptchaTokenV3");
    //console.log(methName+"recaptchaTokenV3="+recaptchaTokenV3);
    if(recaptchaTokenV3===null || recaptchaTokenV3===""){
      setTimeout(function() { this.reset_recaptchaV3_token("init"); }.bind(this), 500);
    }
    this.reset_recaptchaV3_token_TIMER();
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    //-----------
    //PhonePrefix
    //-----------
    let defaultPropsPhonePrefix   = {};
    let filterOptionsPhonePrefix  = {};
    if(this.state.phonePrefix_AUTOCOMPLETE_MODE === "text"){
      defaultPropsPhonePrefix   = { options:this.state.parserObject_getPhonePrefixes4Picker, getOptionLabel:option => option, };
      filterOptionsPhonePrefix  = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS, stringify: option => option, });
    }
    else{
      if(localStorage.getItem("lang")==="en"){ defaultPropsPhonePrefix = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      else                                   { defaultPropsPhonePrefix = { options:this.state.parserObject_getPhonePrefixes, getOptionLabel:option => option.descr ? option.descr : "", }; }
      filterOptionsPhonePrefix = createFilterOptions({matchFrom: this.state.phonePrefix_AUTOCOMPLETE_FILTER_OPTIONS,stringify: (option) => option.descr + option.keywords,});
    }

  //var lang = localStorage.getItem("lang");
  //var parserObject_getLanguages4Picker     = (lang==="el") ? this.state.parserObject_getLanguages4Picker_el     : this.state.parserObject_getLanguages4Picker_en;
  //var preferredLanguage_text               = this.translate_language(     lang,this.state.preferredLanguage_id,  this.state.preferredLanguage_text);

    const path_SettingsTerms      = api.webapp_path+"/SettingsTerms";
    const path_SettingsTermsBills = api.webapp_path+"/SettingsTermsBills";
    const path_SettingsPrivacy    = api.webapp_path+"/SettingsPrivacy";

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={7} md={7}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("RegisterLight1_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("RegisterLight1_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.label1}>{this.NSInforString("RegisterLight1_label1")}</div>
                <div className={classes.label1}>{this.NSInforString("RegisterLight1_label1_b")}</div>
                <div style={{ marginBottom:10 }}></div>
              </GridItem>
            </GridContainer>

            {/* <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.label1}>{this.NSInforString("RegisterLight1_label2")}</div>
              </GridItem>
            </GridContainer> */}

            <GridContainer justify="center">
              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                  <TextField
                    fullWidth
                    autoComplete={this.autoCompleteText_Textfields()}
                    error={this.state.textField0_hasError}
                    className={classes.textField0}
                    id={this.autoCompleteText_Textfields()}
                    label={this.autoCompleteText_Textfields()}
                    value={this.state.textField0}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                  />
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error   ={this.state.email_hasError}
                  disabled={this.state.email_disabled}
                  className={classes.email}
                  id="email"
                  key="email"
                  label={this.NSInforString("RegisterLight1_plh03")}
                  value={this.state.email}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "email"),
                    type: "email"
                  }}
                />
                <div className={classes.label_emailInfo}>{this.NSInforString("RegisterLight1_emailInfo_lbl_lbl1")}</div>
                {/* <div className={classes.label_emailInfo}>{(localStorage.getItem("isLoggedIn")==="true") ? "" : this.NSInforString("RegisterLight1_emailInfo_lbl_lbl1")}</div> */}
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW XXX------------ */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error={this.state.password1_hasError}
                  className={classes.password1}
                  id="password1"
                  key="password1"
                  label={this.NSInforString("RegisterLight1_plh04")}
                  value={this.state.password1}
                  InputProps={{
                    fullWidth: true, onChange: event => this.change(event, "password1"), type:this.get_PasswordType1(), endAdornment:
                      <InputAdornment position="end">
                        <IconButton onClick={this.handlePopoverOpen_password1} onMouseDown={this.handlePopoverOpen_password1} style={{padding:0}}><InfoIcon/></IconButton>
                        <IconButton onClick={this.handlePopoverOpen_passwordType1}  style={{padding:0}}> {this.get_PasswordType1()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                      </InputAdornment>
                  }}
                />
                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                <Popover
                  id="password1_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.password1_popover_isOpen}
                  anchorEl={document.getElementById("password1")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_password1}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("popover_generic_password")}</Typography>
                </Popover>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error={this.state.password2_hasError}
                  className={classes.password2}
                  id="password2"
                  key="password2"
                  label={this.NSInforString("RegisterLight1_plh05")}
                  value={this.state.password2}
                  InputProps={{
                    fullWidth: true, onChange: event => this.change(event, "password2"), onBlur: event => this.blur(event, "password2"), type:this.get_PasswordType2(), endAdornment:
                      <InputAdornment position="end">
                        <IconButton onClick={this.handlePopoverOpen_password2} onMouseDown={this.handlePopoverOpen_password2} style={{padding:0}}><InfoIcon/></IconButton>
                        <IconButton onClick={this.handlePopoverOpen_passwordType2}  style={{padding:0}}> {this.get_PasswordType2()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                      </InputAdornment>
                  }}
                />
                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                <Popover
                  id="password2_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.password2_popover_isOpen}
                  anchorEl={document.getElementById("password2")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_password2}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("popover_generic_password")}</Typography>
                </Popover>
              </GridItem>
              {/* ------------------------- */}
              {/* ----------ROW------------ */}
              {/* ------------------------- */}
              {/* <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth error={this.state.preferredLanguage_hasError} className={classes.preferredLanguage}>
                  <InputLabel id="preferredLanguage_InputLabel">{this.NSInforString("RegisterLight1_plh06")}</InputLabel>
                  <Select
                    displayEmpty
                    id="preferredLanguage"
                    value={preferredLanguage_text+""}
                    onChange={event => this.handleCustomDropDownClick_languages(event)}
                  >
                    {parserObject_getLanguages4Picker.map(function (akey) {
                      return <MenuItem key={akey} value={akey}>{akey}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
              </GridItem> */}
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <div style={{ marginBottom:40}}>
            <GridContainer>
              {this.state.phonePrefix_AUTOCOMPLETE_MODE === "text" ? (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.phonePrefix}>
                  <Autocomplete
                    {...defaultPropsPhonePrefix}
                    id="phonePrefix"
                    value={this.state.phonePrefix_text}
                    disableClearable
                    disabled={this.state.phonePrefix_disabled}
                    onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.phonePrefix_hasError} label={this.NSInforString("RegisterLight1_plh07")} name={this.autoCompleteText_autoCompleteDropDown()}/>}
                  />
                </FormControl>
              </GridItem>
              ) : (
              <GridItem xs={12} sm={12} md={6}>
                <FormControl fullWidth className={classes.phonePrefix}>
                  <Autocomplete
                    filterOptions={filterOptionsPhonePrefix}
                    {...defaultPropsPhonePrefix}
                    id="phonePrefix"
                    value={this.state.phonePrefix_text}
                    disableClearable
                    disabled={this.state.phonePrefix_disabled}
                    onChange={(event,value) => this.handleCustomDropDownClick_phonePrefix(event,value)}
                    renderOption={option => {return (<React.Fragment><img src={images[wu_Utilities.findCountryIdFromCountryName(wu_Utilities.normalizePhoneCountryName(option.descr)).toLowerCase()+".png"]} alt="" width="26" height="17"/><Typography style={{ paddingLeft:10,}}>{option.descr}</Typography></React.Fragment>);}}
                    renderInput={params => <TextField {...params} error={this.state.phonePrefix_hasError} label={this.NSInforString("RegisterLight1_plh07")} name={this.autoCompleteText_autoCompleteDropDown()} />}
                  />
                </FormControl>
              </GridItem>
              ) }
              <GridItem xs={12} sm={12} md={6}>
                <TextField
                  fullWidth
                  error={this.state.phoneNumber_hasError}
                  disabled={this.state.phoneNumber_disabled}
                  className={classes.phoneNumber}
                  id="phoneNumber"
                  key="phoneNumber"
                  label={this.get_RegisterLight1_plh08()}
                  value={this.state.phoneNumber}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "phoneNumber"),
                    type: "text"
                  }}
                />
              </GridItem>
            </GridContainer>
            </div>
            {/* ------------------------------- */}
            {/* ----------[Consent---old]------ */}
            {/* ------------------------------- */}
            {/* {this.state.consent_view_hidden === true ? ( "" ) : (
              <div style={{ marginTop:25, marginBottom:25}}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.RegisterLight1_lbl_consent1}>{this.NSInforString("RegisterLight1_lbl_consent1")}</div>
                  </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <RadioGroup aria-label="gender" name="gender1" value={this.state.consentValue} onChange={this.handleRadioButtonClick_consent}>
                      <FormControlLabel value="true"  control={<Radio />} label={this.NSInforString("RegisterLight1_lbl_sel1")} /><br/>
                      <FormControlLabel value="false" control={<Radio />} label={this.NSInforString("RegisterLight1_lbl_sel2")} />
                    </RadioGroup>
                  </GridItem>
                </GridContainer>
              </div>
            )} */}
            {/* ------------------------------- */}
            {/* ----------[Consent---new]------ */}
            {/* ------------------------------- */}
            {localStorage.getItem("lang")==="en" ?
            (
            <GridContainer justify="center" style={{ marginTop:10}}>
              <GridItem xs={2} sm={1} md={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_userGivesConsent}
                      value="checkedA"
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                />
              </GridItem>
              <GridItem xs={10} sm={11} md={11}>
                <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>I consent to receive updates, news and offers via email, push notifications, SMS, social media ads or other ad platforms or multimedia messages.</span></div>
              </GridItem>
            </GridContainer>
            ) : ( "" )}
            {localStorage.getItem("lang")==="el" ?
            (
              <GridContainer justify="center" style={{ marginTop:10}}>
                <GridItem xs={2} sm={1} md={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={this.handleCheckBoxClick_userGivesConsent}
                        value="checkedA"
                        inputProps={{ 'aria-label': 'Checkbox A' }}
                      />
                    }
                    label=""
                  />
                </GridItem>
                <GridItem xs={10} sm={11} md={11}>
                  <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>Συμφωνώ να λαμβάνω ενημερώσεις για νέα, προωθητικές ενέργειες και διαφημίσεις μέσω email, push notifications, SMS, social media ή άλλων πλατφορμών ή μέσω μηνυμάτων πολυμέσων.</span></div>
                </GridItem>
              </GridContainer>
            ) : ( "" )}
            {/* ------------------------- */}
            {/* ----------[Terms]-------- */}
            {/* ------------------------- */}
            {localStorage.getItem("lang")==="en" ?
            (
            <GridContainer justify="center" style={{ marginTop:10}}>
              <GridItem xs={2} sm={1} md={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_userAcceptedTerms}
                      value="checkedA"
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                />
              </GridItem>
              <GridItem xs={10} sm={11} md={11}>
                <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>I have read and accept the <NavLink activeClassName="active" exact to={path_SettingsTerms}>Terms & Conditions for Western Union</NavLink> and <NavLink activeClassName="active" exact to={path_SettingsTermsBills}>Terms & Conditions for Bill Payments</NavLink> and I have been informed about the <NavLink activeClassName="active" exact to={path_SettingsPrivacy}>Privacy Statement</NavLink></span></div>
              </GridItem>
            </GridContainer>
            ) : ( "" )}
            {localStorage.getItem("lang")==="el" ?
            (
              <GridContainer justify="center" style={{ marginTop:10}}>
                <GridItem xs={2} sm={1} md={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={this.handleCheckBoxClick_userAcceptedTerms}
                        value="checkedA"
                        inputProps={{ 'aria-label': 'Checkbox A' }}
                      />
                    }
                    label=""
                  />
                </GridItem>
                <GridItem xs={10} sm={11} md={11}>
                  <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>Διάβασα και αποδέχομαι τους <NavLink activeClassName="active" exact to={path_SettingsTerms}>Όρους & Προϋποθέσεις Western Union</NavLink> και τους <NavLink activeClassName="active" exact to={path_SettingsTermsBills}>Όρους & Προϋποθέσεις Πληρωμής Λογαριασμών</NavLink> και ενημερώθηκα για την <NavLink activeClassName="active" exact to={path_SettingsPrivacy}>Πολιτική Προσωπικών Δεδομένων</NavLink></span></div>
                </GridItem>
              </GridContainer>
            ) : ( "" )}
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <div>
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.labelHeader}>&nbsp;</div>
                  {/* -----------recaptcha_NONE -------------- */}
                  {this.state.recaptchaVersionSupported === "NONE" ? (
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={this.btn_next_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_next_act}
                        type="submit">
                        {this.NSInforString("RegisterLight1_btn_next") }
                      </CustomButton>
                    </div>
                  ) : ( "" )}
                  {/* -----------recaptcha_V2 -------------- */}
                  {this.state.recaptchaVersionSupported === "V2" ? (
                    <div className={classes.textCenter}>
                      <ReCAPTCHA
                        ref={ ref => this.recaptchaRef = ref }
                        locale={localStorage.getItem("lang")}
                        sitekey={api.captchKey}
                        onResolved={this.btn_next_act} />
                      <CustomButton
                        disabled={this.btn_next_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_next_act_with_recaptcha}
                        type="submit">
                        {this.NSInforString("RegisterLight1_btn_next") }
                      </CustomButton>
                    </div>
                  ) : ( "" )}
                  {/* -----------recaptcha_V3 -------------- */}
                  {this.state.recaptchaVersionSupported === "V3" ? (
                    <div className={classes.textCenter}>
                      <GoogleReCaptchaProvider reCaptchaKey={api.captchKeyV3}>
                        <GoogleReCaptcha
                            className="google-recaptcha-custom-class"
                            onVerify={this.btn_next_act_get_recaptchaV3_token}
                            refreshReCaptcha={this.state.refreshReCaptchaV3}
                        />
                      </GoogleReCaptchaProvider>
                      <CustomButton
                        disabled={this.btn_next_act_isDisabled()}
                        className={classes.yellowButton}
                        color="rose"
                        onClick={this.btn_next_act}
                        type="submit">
                        {this.NSInforString("RegisterLight1_btn_next")}
                      </CustomButton>
                    </div>
                  ) : ( "" )}
                </GridItem>
              </GridContainer>
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {api.backButtonAtBottom === true ? (
                <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <div className={classes.textCenter}>
                      <CustomButton
                        disabled={false}
                        className={classes.backButton}
                        color="rose"
                        onClick={this.goBack}>
                        {this.NSInforString("RegisterLight1_btn_prev")}
                      </CustomButton>
                    </div>
                  </GridItem>
                </GridContainer>
              ) : ( "" ) }
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={3000} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* --------------------------------------- */}
        {/* ----------[POPUP checkAppVersion]------ */}
        {/* --------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_checkAppVersion_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_checkAppVersion_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_checkAppVersion_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_checkAppVersion} color="default" onClick={this.dialog_checkAppVersion_btn_ok}>{this.NSInforString("dialog_checkAppVersion_btn_ok")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
        {/* ------------------------------ */}
        {/* ----------[POPUP][CAMPAIGN]--- */}
        {/* ------------------------------ */}
        <div>
          <Dialog
            open={this.state.dialog101_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog101_handleClose}
            aria-labelledby="alert-dialog101-slide-title"
            aria-describedby="alert-dialog101-slide-description"
          >
            <DialogTitle id="alert-dialog101-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="el" ? (
              <DialogContent><img src={WU_popup_campaign_el} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            ) : (
              <DialogContent><img src={WU_popup_campaign_en} alt=""  width={this.state.dialog101_campaign_image_w} height={this.state.dialog101_campaign_image_h}/></DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog101_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  // handleCustomDropDownClick_languages(event) {
  //   let methName = filename+"handleCustomDropDownClick_languages ";
  //   let eventTMP = event.target.value+"";
  //   if(api.print_logs){console.log(methName+eventTMP);}
  //   this.setState({ "preferredLanguage_text":eventTMP });
  //   if(localStorage.getItem("lang")==="el"){
  //     for(let i=0; i<this.state.parserObject_getLanguages4Picker_el.length; ++i){
  //       if(this.state.parserObject_getLanguages4Picker_el[i]===eventTMP){
  //         this.setState({
  //           "preferredLanguage_id"       : this.state.parserObject_getLanguages_el[i].lang_wu_id,
  //           "preferredLanguage_hasError" : false,
  //         });
  //         break;
  //       }
  //     }
  //   }
  //   else{
  //     for(let i=0; i<this.state.parserObject_getLanguages4Picker_en.length; ++i){
  //       if(this.state.parserObject_getLanguages4Picker_en[i]===eventTMP){
  //         this.setState({
  //           "preferredLanguage_id"       : this.state.parserObject_getLanguages_en[i].lang_wu_id,
  //           "preferredLanguage_hasError" : false,
  //         });
  //         break;
  //       }
  //     }
  //   }
  //
  //   setTimeout(function() {
  //     this.saveState();
  //   }.bind(this), 250);
  // }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_phonePrefix(event,value) {
    let methName = filename+"handleCustomDropDownClick_phonePrefix ";
    let event_target_value = null;
    let eventTMP1          = null;
    let eventTMP2          = null;
    if(this.state.phonePrefix_AUTOCOMPLETE_MODE === "text"){
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
    }
    else{
      event_target_value = (event.target.value===null || (typeof event.target.value === "undefined")) ? "" : event.target.value;
      eventTMP1          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value;
      eventTMP2          = (value===null || (typeof value === "undefined")) ? event_target_value+"" : value.descr;
    }
    if(api.print_logs){console.log(methName+"eventTMP1 = " + eventTMP1);}
    if(api.print_logs){console.log(methName+"eventTMP2 = " + eventTMP2);}
    if(api.print_logs){console.log(methName+"event     = " + event);}
    if(api.print_logs){console.log(methName+"value     = " + value);}

    this.setState({
      "phonePrefix_text"     : eventTMP1,
      "phonePrefix_hasError" : false,
    });
    for(let i=0; i<this.state.parserObject_getPhonePrefixes4Picker.length; ++i){
      if(this.state.parserObject_getPhonePrefixes4Picker[i]===eventTMP2){
        this.setState({ "phonePrefix_id":this.state.parserObject_getPhonePrefixes[i].c2c_wu_id });
        //console.log('this.state.parserObject_getPhonePrefixes[i].c2c_wu_id='+this.state.parserObject_getPhonePrefixes[i].c2c_wu_id);
        if(this.state.parserObject_getPhonePrefixes[i].c2c_wu_id!=="30"){
          this.setState({"phoneNumber_hasError" : false });
        }
        break;
      }
    }

    setTimeout(function() {
      this.saveState();
    }.bind(this), 250);
  }
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_isMobile(event) {
    let methName = filename+"handleCheckBoxClick_isMobile ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "isMobile":  event.target.checked });

    if(this.state.phonePrefix_id === "30"){
      let textField4btext = this.state.phoneNumber.trim();
      if(event.target.checked===true){
          if(this.verifyGenericItem("phone_mobile",textField4btext)===false){
            console.log('1 this.state.isMobile='+this.state.isMobile+",textField4btext="+textField4btext);
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
            return;
          }
          else{
              this.setState({"phoneNumber_hasError" : false });
          }
      }
      if(event.target.checked===false){
          if(this.verifyGenericItem("phone_landline",textField4btext)===false){
            console.log('2 this.state.isMobile='+this.state.isMobile+",textField4btext="+textField4btext);
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
            return;
          }
          else{
              this.setState({"phoneNumber_hasError" : false });
          }
      }
    }

    setTimeout(function() {
      this.saveState();
    }.bind(this), 250);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_userAcceptedTerms(event) {
    let methName = filename+"handleCheckBoxClick_userAcceptedTerms ";
    if(api.print_logs){console.log(methName+event.target.checked);}

    let event_target_checked = event.target.checked;
    this.setState({ "userAcceptedTerms":event_target_checked });
    //console.log(methName+event.target.checked);
    //console.log(methName+event_target_checked);

    setTimeout(function() {
      this.saveState();
    }.bind(this), 250);
  }
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_userGivesConsent(event) {
    let methName = filename+"handleCheckBoxClick_userGivesConsent ";
    if(api.print_logs){console.log(methName+event.target.checked);}

    let event_target_checked = event.target.checked;
    this.setState({ "userGivesConsent":event_target_checked });
    //console.log(methName+event.target.checked);
    //console.log(methName+event_target_checked);

    setTimeout(function() {
      this.saveState();
    }.bind(this), 250);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  //Consent---old
  /*handleRadioButtonClick_consent(event) {
    let methName = filename+"handleRadioButtonClick_consent ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}

    if(eventTMP==="true"){
      localStorage.setItem("wantMktInfo","1");
      this.setState({
        "consentValue" : eventTMP,
        "bool_sel1"    : true,
        "bool_sel2"    : false
      });
    }
    else{
      localStorage.setItem("wantMktInfo","0");
      this.setState({
        "consentValue" : eventTMP,
        "bool_sel1"    : false,
        "bool_sel2"    : true
      });
    }

    setTimeout(function() {
      this.saveState();
    }.bind(this), 250);
  }*/
  // translate_language(lang,preferredLanguage_id, preferredLanguage_text){
  //   if(lang==="el"){
  //     for(let i=0; i<this.state.parserObject_getLanguages_el.length; ++i){ if(this.state.parserObject_getLanguages_el[i]["lang_wu_id"]===preferredLanguage_id){ return this.state.parserObject_getLanguages_el[i]["descr_el"] } }
  //   }
  //   else{
  //     for(let i=0; i<this.state.parserObject_getLanguages_en.length; ++i){ if(this.state.parserObject_getLanguages_en[i]["lang_wu_id"]===preferredLanguage_id){ return this.state.parserObject_getLanguages_en[i]["descr_en"] } }
  //   }
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------recaptcha_V3--------------------------------------
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  reset_recaptchaV3_token_TIMER = function() {
      var self = this;
      this.timer = setInterval(function() {
          self.reset_recaptchaV3_token("init");
      }, 90000)
  }
  //----------------------------------------------------------------------------------------------------
  reset_recaptchaV3_token(status) {
    let methName = filename+"reset_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if(this.state.recaptchaVersionSupported==="V3"){
      if(status==="init")   { this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(status==="success"){ localStorage.setItem("recaptchaTokenV3", ""); /*this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3();*/ return; }
      if(status==="failure"){ this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(api.print_logs){console.log(methName+"this.state.refreshReCaptchaV3="+this.state.refreshReCaptchaV3);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  generateRecaptchaV3(status) {
    let methName = filename+"generateRecaptchaV3 ";
    //if(api.print_logs){console.log(methName);}

    window.grecaptcha.execute(api.captchKeyV3, {action: "YOUR_ACTION_NAME"}).then(function(token) {
      if (token) {
        if(api.print_logs){console.log(methName+"status="+status+" token= "+token);}
        localStorage.setItem("recaptchaTokenV3", token);
      }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act_with_recaptcha(event) {
    let methName = filename+"btn_next_act_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.email.trim() === "")            { this.setState({"email_hasError"             : true }); emptyFields = true; }
      if(this.state.password1.trim() === "")        { this.setState({"password1_hasError"         : true }); emptyFields = true; }
      if(this.state.password2.trim() === "")        { this.setState({"password2_hasError"         : true }); emptyFields = true; }
      if(this.state.phonePrefix_text === "")        { this.setState({"phonePrefix_hasError"       : true }); emptyFields = true; }//phonePrefix_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.phoneNumber.trim() === "")      { this.setState({"phoneNumber_hasError"       : true }); emptyFields = true; }
      if(this.state.preferredLanguage_id === "")    { this.setState({"preferredLanguage_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //--------------
    //validate email---TextField
    //--------------
    let emailBase64    = new Buffer(this.state.email.trim()).toString('base64');
    let email          = this.state.email.trim();
    let textField3text = this.state.email.trim();
    localStorage.setItem("HTTP_user", email);
    console.log("HTTP_user="+localStorage.getItem("HTTP_user").trim());
    if(textField3text === ""){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1_plh03")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    if(this.verifyGenericItem("email",textField3text)===false){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    let passwordBase64 = "";
    //-----------------
    //validate Password---TextField
    //-----------------
    let textField4text = this.state.password1.trim();
    if(textField4text === ""){
      this.setState({"password1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1_plh04")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    let textField4text_hasGreekChar = false;
    for(let i=0; textField4text.length>0 && i<textField4text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField4text[i])===true){ textField4text_hasGreekChar=true; break; } }
    if(textField4text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //-------------------------
    //validate Confirm Password---TextField
    //-------------------------
    let textField5text = this.state.password2.trim();
    if(textField5text === ""){
      this.setState({"password2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1_plh05")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    let textField5text_hasGreekChar = false;
    for(let i=0; textField5text.length>0 && i<textField5text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField5text[i])===true){ textField5text_hasGreekChar=true; break; } }
    if(textField5text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //----------------------
    //passwords do not match
    //----------------------
    if(textField4text !== textField5text){
      this.setState({"password1_hasError" : true });
      this.setState({"password2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("passwords.do.not.match"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    passwordBase64 = new Buffer(this.state.password1.trim()).toString('base64');

    //-----------------
    //validate Language---Picker
    //-----------------
    // let language = this.state.preferredLanguage_id;
    // if(language === ""){
    //   this.setState({"preferredLanguage_hasError" : true });
    //   this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight1_plh06"));
    //   if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
    //   return;
    // }
    //-----------------
    //validate Language---Preferences
    //-----------------
    let language =  (localStorage.getItem("lang")==="el") ? "el" : "en";
    //---------------------
    //validate Phone Number---TextField
    //---------------------
    let telephone       = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField6text  = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField6btext = this.state.phoneNumber.trim();
    let isMobile        = this.state.isMobile ? "1" : "0";
    if(localStorage.getItem("isLoggedIn")==="true"){;}
    else                                           {isMobile="1";}
    if(api.print_logs){console.log("this.state.phonePrefix_id = "+this.state.phonePrefix_id);}
    if(api.print_logs){console.log("this.state.phoneNumber    = "+this.state.phoneNumber);}
    if(textField6text === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.setState({"phoneNumber_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.get_RegisterLight1_plh08()+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
        return;
    }
    if(this.state.phonePrefix_id === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.phone.prefix.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
        return;
    }
    if(this.state.phonePrefix_id === "30"){
        if(textField6btext.length !== 10){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.size"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
            return;
        }
        if(localStorage.getItem("isLoggedIn")==="true"){
          if(this.state.isMobile===true && this.verifyGenericItem("phone_mobile",textField6btext)===false){
              console.log('1 this.state.isMobile='+this.state.isMobile+",textField6btext="+textField6btext);
              this.setState({"phoneNumber_hasError" : true });
              this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
              if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
              return;
          }
          if(this.state.isMobile===false && this.verifyGenericItem("phone_landline",textField6btext)===false){
              console.log('2 this.state.isMobile='+this.state.isMobile+",textField6btext="+textField6btext);
              this.setState({"phoneNumber_hasError" : true });
              this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
              if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
              return;
          }
        }
        else{
          if(this.verifyGenericItem("phone_mobile",textField6btext)===false){
              console.log('1 this.state.isMobile='+this.state.isMobile+",textField6btext="+textField6btext);
              this.setState({"phoneNumber_hasError" : true });
              this.dialog_handleOpen(this.NSInforString("common.phone.greece_SMS.format"));
              if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
              return;
          }
        }
    }
    else{
      //if(textField6btext.length < 10 || textField6btext.length>24){
        if(textField6btext.length < 7 || textField6btext.length>24){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.inter.size_7_24"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
            return;
        }
    }
    //-----------------------
    //validate Consent-offers---old
    //-----------------------
    //let wantMktInfo = "";
    //if(this.state.bool_sel1===true  && this.state.bool_sel2===false){ wantMktInfo = "1"; }
    //if(this.state.bool_sel1===false && this.state.bool_sel2===true) { wantMktInfo = "0"; }
    //-----------------------
    //validate Consent-offers---new
    //-----------------------
    let wantMktInfo = "";
    if(this.state.userGivesConsent===true) { wantMktInfo = "1"; }
    if(this.state.userGivesConsent===false){ wantMktInfo = "0"; }
    //--------------
    //validate Terms---CheckBox
    //--------------
    if(this.state.userAcceptedTerms===false){
      this.dialog_handleOpen(this.NSInforString("RegisterLight1_msg_terms"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    if(api.print_logs){console.log(methName+"emailBase64    = "+emailBase64);}
    if(api.print_logs){console.log(methName+"passwordBase64 = "+passwordBase64);}
    if(api.print_logs){console.log(methName+"language       = "+language);}
    if(api.print_logs){console.log(methName+"telephone      = "+telephone);}
    if(api.print_logs){console.log(methName+"isMobile       = "+isMobile);}
    if(api.print_logs){console.log(methName+"wantMktInfo    = "+wantMktInfo);}
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.btn_next_act_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  btn_next_act_get_recaptchaV3_token(token) {
    let methName = filename+"btn_next_act_get_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if (token && token.length>300) {
      if(api.print_logs){console.log(methName+new Date()+" token=" +token);}
      localStorage.setItem("recaptchaTokenV3", token);
    }
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); this.stopLockers();return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.email.trim() === "")            { this.setState({"email_hasError"             : true }); emptyFields = true; }
      if(this.state.password1.trim() === "")        { this.setState({"password1_hasError"         : true }); emptyFields = true; }
      if(this.state.password2.trim() === "")        { this.setState({"password2_hasError"         : true }); emptyFields = true; }
      if(this.state.phonePrefix_text === "")        { this.setState({"phonePrefix_hasError"       : true }); emptyFields = true; }//phonePrefix_AUTOCOMPLETE_MODE(do not trim)
      if(this.state.phoneNumber.trim() === "")      { this.setState({"phoneNumber_hasError"       : true }); emptyFields = true; }
      if(this.state.preferredLanguage_id === "")    { this.setState({"preferredLanguage_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");this.stopLockers();return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    //--------------
    //validate email---TextField
    //--------------
    let emailBase64    = new Buffer(this.state.email.trim()).toString('base64');
    let email          = this.state.email.trim();
    let textField3text = this.state.email.trim();
    localStorage.setItem("HTTP_user", email);
    console.log("HTTP_user="+localStorage.getItem("HTTP_user").trim());
    if(textField3text === ""){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1_plh03")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    if(this.verifyGenericItem("email",textField3text)===false){
      this.setState({"email_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    let passwordBase64 = "";
    //-----------------
    //validate Password---TextField
    //-----------------
    let textField4text = this.state.password1.trim();
    if(textField4text === ""){
      this.setState({"password1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1_plh04")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    let textField4text_hasGreekChar = false;
    for(let i=0; textField4text.length>0 && i<textField4text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField4text[i])===true){ textField4text_hasGreekChar=true; break; } }
    if(textField4text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    //-------------------------
    //validate Confirm Password---TextField
    //-------------------------
    let textField5text = this.state.password2.trim();
    if(textField5text === ""){
      this.setState({"password2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("RegisterLight1_plh05")+"\"");
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    let textField5text_hasGreekChar = false;
    for(let i=0; textField5text.length>0 && i<textField5text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField5text[i])===true){ textField5text_hasGreekChar=true; break; } }
    if(textField5text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    //----------------------
    //passwords do not match
    //----------------------
    if(textField4text !== textField5text){
      this.setState({"password1_hasError" : true });
      this.setState({"password2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("passwords.do.not.match"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    passwordBase64 = new Buffer(this.state.password1.trim()).toString('base64');

    //-----------------
    //validate Language---Picker
    //-----------------
    // let language = this.state.preferredLanguage_id;
    // if(language === ""){
    //   this.setState({"preferredLanguage_hasError" : true });
    //   this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("RegisterLight1_plh06"));
    //   if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
    //   this.stopLockers();return;
    // }
    //-----------------
    //validate Language---Preferences
    //-----------------
    let language =  (localStorage.getItem("lang")==="el") ? "el" : "en";
    //---------------------
    //validate Phone Number---TextField
    //---------------------
    let telephone       = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField6text  = this.state.phonePrefix_id+"-"+this.state.phoneNumber.trim();
    let textField6btext = this.state.phoneNumber.trim();
    let isMobile        = this.state.isMobile ? "1" : "0";
    if(localStorage.getItem("isLoggedIn")==="true"){;}
    else                                           {isMobile="1";}
    if(api.print_logs){console.log("this.state.phonePrefix_id = "+this.state.phonePrefix_id);}
    if(api.print_logs){console.log("this.state.phoneNumber    = "+this.state.phoneNumber);}
    if(textField6text === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.setState({"phoneNumber_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.get_RegisterLight1_plh08()+"\"");
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_id === ""){
        this.setState({"phonePrefix_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("common.phone.prefix.size"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
        this.stopLockers();return;
    }
    if(this.state.phonePrefix_id === "30"){
        if(textField6btext.length !== 10){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.greece.size"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
            this.stopLockers();return;
        }
        if(localStorage.getItem("isLoggedIn")==="true"){
          if(this.state.isMobile===true && this.verifyGenericItem("phone_mobile",textField6btext)===false){
              console.log('1 this.state.isMobile='+this.state.isMobile+",textField6btext="+textField6btext);
              this.setState({"phoneNumber_hasError" : true });
              this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
              if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
              this.stopLockers();return;
          }
          if(this.state.isMobile===false && this.verifyGenericItem("phone_landline",textField6btext)===false){
              console.log('2 this.state.isMobile='+this.state.isMobile+",textField6btext="+textField6btext);
              this.setState({"phoneNumber_hasError" : true });
              this.dialog_handleOpen(this.NSInforString("common.phone.greece.format"));
              if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
              this.stopLockers();return;
          }
        }
        else{
          if(this.verifyGenericItem("phone_mobile",textField6btext)===false){
              console.log('1 this.state.isMobile='+this.state.isMobile+",textField6btext="+textField6btext);
              this.setState({"phoneNumber_hasError" : true });
              this.dialog_handleOpen(this.NSInforString("common.phone.greece_SMS.format"));
              if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
              this.stopLockers();return;
          }
        }
    }
    else{
      //if(textField6btext.length < 10 || textField6btext.length>24){
        if(textField6btext.length < 7 || textField6btext.length>24){
            this.setState({"phoneNumber_hasError" : true });
            this.dialog_handleOpen(this.NSInforString("common.phone.inter.size_7_24"));
            if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
            this.stopLockers();return;
        }
    }
    //-----------------------
    //validate Consent-offers---old
    //-----------------------
    //let wantMktInfo = "";
    //if(this.state.bool_sel1===true  && this.state.bool_sel2===false){ wantMktInfo = "1"; }
    //if(this.state.bool_sel1===false && this.state.bool_sel2===true) { wantMktInfo = "0"; }
    //-----------------------
    //validate Consent-offers---new
    //-----------------------
    let wantMktInfo = "";
    if(this.state.userGivesConsent===true) { wantMktInfo = "1"; }
    if(this.state.userGivesConsent===false){ wantMktInfo = "0"; }
    //--------------
    //validate Terms---CheckBox
    //--------------
    if(this.state.userAcceptedTerms===false){
      this.dialog_handleOpen(this.NSInforString("RegisterLight1_msg_terms"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers();return;
    }
    //+++++++++++
    //[RECAPTCHA]
    //+++++++++++
    var recaptchaVerify = "";
    //recaptcha_V2
    if(this.state.recaptchaVersionSupported==="V2"){
      recaptchaVerify = shouldResetCaptcha ? JSON.stringify(this.recaptchaRef.getResponse()) : "";
      if(api.print_logs){console.log(methName+"recaptchaVerify token= "+recaptchaVerify);}
    }
    //recaptcha_V3
    if(this.state.recaptchaVersionSupported==="V3"){
      recaptchaVerify = localStorage.getItem("recaptchaTokenV3");
      if(api.print_logs){console.log(methName+"recaptchaVerify token= "+recaptchaVerify);}
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let parserObject_omtregistrationTriggerOTP_req = {};
    parserObject_omtregistrationTriggerOTP_req["telephone"]          = telephone;                    //"30-6932554149"
    parserObject_omtregistrationTriggerOTP_req["isMobile"]           = isMobile;//"1";               //0,1
    parserObject_omtregistrationTriggerOTP_req["email"]              = emailBase64;                  //user@mail.com
    parserObject_omtregistrationTriggerOTP_req["emailPlain"]         = email;                        //user@mail.com
    parserObject_omtregistrationTriggerOTP_req["preferredLanguage"]  = language;                     //el,en
    parserObject_omtregistrationTriggerOTP_req["password"]           = passwordBase64;               //base64 encoded password
    parserObject_omtregistrationTriggerOTP_req["passwordPlain"]      = textField4text;               //password plain
    parserObject_omtregistrationTriggerOTP_req["wantMktInfo"]        = wantMktInfo;                  //"1","0"
    parserObject_omtregistrationTriggerOTP_req["recaptchaVerify"]    = recaptchaVerify;

    localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", JSON.stringify(parserObject_omtregistrationTriggerOTP_req));

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------
      //checkAppVersion
      //---------------
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="RegisterLight1"){if(api.print_logs){console.log(methName+"5A11");}this.stopLockers();return;}//5A11
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("success");
        //this.stopLockers();this.stopSpinners();
        parserObject_omtregistrationTriggerOTP_req["val1"] = res.val1;

        //-------------------------
        //omtregistrationTriggerOTP
        //-------------------------
        wu_RegisterLightService
        .wu_omtregistrationTriggerOTP(parserObject_omtregistrationTriggerOTP_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="RegisterLight1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("success");
          this.stopLockers();this.stopSpinners();
          //+++++++++++++++
          //Goto Controller
          //+++++++++++++++
          parserObject_omtregistrationTriggerOTP_req["isMobile"]           = "";
          parserObject_omtregistrationTriggerOTP_req["emailPlain"]         = ""; //user@mail.com
          parserObject_omtregistrationTriggerOTP_req["preferredLanguage"]  = "";
          parserObject_omtregistrationTriggerOTP_req["password"]           = ""; //base64 encoded password
          parserObject_omtregistrationTriggerOTP_req["passwordPlain"]      = ""; //password plain
          parserObject_omtregistrationTriggerOTP_req["wantMktInfo"]        = ""; //"1","0"
          parserObject_omtregistrationTriggerOTP_req["recaptchaVerify"]    = "";
          localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", JSON.stringify(parserObject_omtregistrationTriggerOTP_req));

          localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
          history.push(wu_Utilities.getNavigationURLs("RegisterLight1OTP"));
        })
        .catch(err => { //wu_omtregistrationTriggerOTP
          localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", "");//Clear Sensitive Data
          if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("failure");
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      })
      .catch(err => { //wu_checkAppVersion
        localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", "");//Clear Sensitive Data
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("failure");
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  blur(event, stateVar) {
    //let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(stateVar==="password2"){
      let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

      let textField1text = this.state.password1.trim();
      let textField2text = this.state.password2.trim();
      if(textField1text !== textField2text){
        this.setState({"password1_hasError" : true });
        this.setState({"password2_hasError" : true });
        this.dialog_handleOpen(this.NSInforString("passwords.do.not.match"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
        return;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="email"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "email"          : eventTMP,
        "email_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      //eventTMP = eventTMP.replace(/ /g,"");
      //eventTMP = eventTMP.replace(/_/g,"");
      //eventTMP = eventTMP.replace(/@/g,"");
      //eventTMP = eventTMP.replace(/\./g,"");
      //if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP)===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); return; }
    }
    else if(stateVar==="password1"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "password1"          : eventTMP,
        "password1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"password1_hasError":true}); return; } }
    }
    else if(stateVar==="password2"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "password2"          : eventTMP,
        "password2_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"password2_hasError":true}); return; } }
    }
    else if(stateVar==="phoneNumber"){
      //eventTMP = eventTMP.toUpperCase();
      this.setState({
        "phoneNumber"          : eventTMP,
        "phoneNumber_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      //if(this.state.countryResidence_id==="GR"){
        if(eventTMP.trim().startsWith("69")===true){this.setState({ "isMobile":  true }); }
        else                                       {this.setState({ "isMobile":  false });}
      //}
    }

    setTimeout(function() {
      this.saveState();
    }.bind(this), 250);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email")                            { return wu_Utilities.wu_verifyEmail(val); }
    if(key==="phone_landline")                   { return wu_Utilities.offline_validate_phone_landline(val);  }
    if(key==="phone_mobile")                     { return wu_Utilities.offline_validate_phone_mobile(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  saveState(){
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  get_RegisterLight1_plh08(){
    if(localStorage.getItem("isLoggedIn")==="true"){
      return this.NSInforString("RegisterLight1_plh08");
    }
    else{
      return this.NSInforString("RegisterLight1_plh08b");
    }
  }
  //----------------------------------------------------------------------------------------------------
  getCountryImageSrc(country) {
    if(country.toUpperCase()==="DE"){return "assets/img/wu/testImg2.png";}
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  //https://stackoverflow.com/questions/21188420/javascript-date-validation-not-validation-february-31
  isValidDate(year, month, day) {
    let methName = filename+"isValidDate ";
    if(api.print_logs){console.log(methName);}

    try{
      let year_int  = parseInt(year);
      let month_int = parseInt(month)-1;
      let day_int   = parseInt(day);
      var d = new Date(year_int, month_int, day_int);
      //console.log(methName+"d.getFullYear()="+d.getFullYear()+" year_int="+year_int);
      //console.log(methName+"d.getMonth()   ="+d.getMonth()+"    month_int="+month_int);
      //console.log(methName+"d.getDate()    ="+d.getDate()+"     day_int="+day_int);
      if (d.getFullYear() === year_int && d.getMonth() === month_int && d.getDate() === day_int) {
          return true;
      }
    }catch(err){
      console.log(methName+"err="+err)
      return false;
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"RG1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups checkAppVersion----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_checkAppVersion_isOpen" : true,
        "dialog_checkAppVersion_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_btn_ok(){
    window.location.reload(true);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[POPOVER]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  handlePopoverOpen_password1(){
    this.setState({ "password1_popover_isOpen" : true, });
  }
  handlePopoverClose_password1(){
    this.setState({ "password1_popover_isOpen" : false, });
  }
  //----------------------------------------------------------------------------------------------------
  handlePopoverOpen_password2(){
    this.setState({ "password2_popover_isOpen" : true, });
  }
  handlePopoverClose_password2(){
    this.setState({ "password2_popover_isOpen" : false, });
  }
  //----------------------------------------------------------------------------------------------------
  get_PasswordType1(){
    return this.state.passwordType1;
  }
  handlePopoverOpen_passwordType1(){
    if(this.state.passwordType1==="password"){this.setState({ "passwordType1" : "text", });}
    if(this.state.passwordType1==="text")    {this.setState({ "passwordType1" : "password", });}
  }
  get_PasswordType2(){
    return this.state.passwordType2;
  }
  handlePopoverOpen_passwordType2(){
    if(this.state.passwordType2==="password"){this.setState({ "passwordType2" : "text", });}
    if(this.state.passwordType2==="text")    {this.setState({ "passwordType2" : "password", });}
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( RegisterLight1_continue_locked===true ){ return true;  }
    else                                       { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    RegisterLight1_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    RegisterLight1_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[COOKIES]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_transfer_cookies(){
    let methName = filename+"clear_cardpayment_transfer_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
    //try{ Cookies.remove('platform',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //try{ Cookies.remove('platform',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_bill_cookies(){
    let methName = filename+"clear_cardpayment_bill_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
}
RegisterLight1.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(RegisterLight1Style)(RegisterLight1)
);
